import * as z from 'zod';

import { permissionsFormSchema } from './permissions-query-schema';
import { userRoleQuerySchema } from './user-role-query-schema';

export const userRoleFormSchema = userRoleQuerySchema.extend({
  azure_role_id: z.string(),
  permissions: z.array(permissionsFormSchema),
});

export type UserRoleFormSchema = z.infer<typeof userRoleFormSchema>;
